export const FontFamilies = {
  Arial: 'Arial',
  TimesNewRoman: 'Times New Roman',
  Helvetica: 'Helvetica',
  Georgia: 'Georgia',
  Brandon: 'Brandon Text',
  Lato: 'Lato',
  OpenSans: 'Open Sans',
  Roboto: 'Roboto',
  RobotoSlab: 'Roboto Slab',
  Overpass: 'Overpass',
}


// WEBPACK FOOTER //
// ./src/scripts/components/shared/PlaybookPreviews/constants.js